import queryString from "query-string";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Header from "../../components/header/Gnb";
import Breadcrumb from "../../components/header/BreadCrumb";
import Footer from "../../components/footer/FooterComponent";
import EditorComponent from "../../components/editorPageComponents/EditorComponent";

import changeLang from "../../utils/changeLanguage";
import "../../assets/css/example.scss";

const RUN_EXAMPLE = "run-example";

function RunExample() {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams();
  const [title, setTitle] = useState();

  const query = queryString.parse(location.search);

  useEffect(() => {
    setTitle(query.title ? query.title : "ActionTitle");
  }, []);

  useEffect(() => {
    if (!(lang === "en-us" || lang === "" || lang === undefined)) {
      navigate(`/${RUN_EXAMPLE}${location.search}`);
    }

    changeLang(lang);
  }, [lang]);

  return (
    <Box id="example-page">
      <Header pageType={RUN_EXAMPLE} />
      <Breadcrumb pageType={RUN_EXAMPLE} />
      <Box className="ex-main" >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box className="webhwp-ex-title">
              <Box className="webhwp-ex-title-title">
                <b>{title}</b>
              </Box>
              <Box className="webhwp-ex-title-desc">
                <Trans i18nKey="content.title.desc" ns="translation" />
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <EditorComponent />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
}

export default RunExample;
